export default {
  newYear: {
    apply: {
      title: '新春行大运行山活动',
      inviteConfirm: '邀请你一起参与',
      home: {
        title: '新春行大运',
        bg: 'static/newYear/7296-HikingSpring-750x460-sc.jpg',
        subTitle: '全港动起来 向健康出发 为健康 一齐行',
        actTime: '活动日期:',
        process: ['报名开始（额满即止）', '截止报名', '活动日'],
        actDetail: {
          title: '活动详情',
          content: ['由中国移动香港及中国香港旅行远足联会主办，香港少年领袖团全力支持，目的是推动全港市民参与，提高市民步行及行山的健康意识，由健康出发，加强「为健康，一齐行」信念。',
            '新春行大运鼓励市民在2月17日结伴参与及一同享用新春盆菜，在节日共享欢乐时光。当日亦会举办新春行大运「万步有礼」活动，鼓励全港市民在全港任何一个角落一齐行，以健康的体魄迎接新一年。',
            '举行日期 : 2019年2月17日',
            '活动时间：上午10时至下午3时',
            '报名日期：2019年1月31日 中午12:00 (先到先得)',
            '活动秘书处',
            '电话：2127 4720 (星期一至五早上10时至晚上7时)',
            '电邮：wewalk.enquiry@gmail.com'
          ]
        },
        route: {
          title: '行山路径',
          startPoint: '起点：北潭涌 伤健乐园',
          routeList: [{
            name: '北潭涌 伤健乐园 至 香港少年领袖团万宜训练营',
            timeLabel: '行程：',
            time: '约小時',
            lengthLabel: '长度：',
            length: '5.8公里',
            linkLabel: '详情 >',
            link: '/mylink/?currentGroup=0&currentContent=0&ishshhkhiking=1&isPark=0&sightname=北潭涌伤健乐园→香港少年领袖团万宜训练营&lang=sc&/#/xingshan/route/11'
          }]
        },
        traffic: {
          title: '交通',
          content: ['自行乘坐公共交通工具到达集合地点，或乘坐大会专车由九龙塘出发',
            '公共交通：从西贡码头乘搭94号巴士至北潭涌站下车又或是乘搭7号或9号专线小巴于北潭涌下车'
          ]
        },
        submitConfirm: '参加活动'
      },
      sign: {
        title: '活动报名',
        nameLabel: '姓名',
        userName: '姓名',
        userNamePlaceholder: '请输入姓名',
        phoneLabel: '手提电话',
        phonePlaceholder: '请输入联系电话',
        emailLabel: '电邮地址',
        emailPlaceholder: '请输入电邮地址',
        emergencyName: '紧急联络人姓名',
        emergencyNamePlaceholder: '请输入紧急联络人姓名',
        emergencyPhone: '紧急联系人手提电话：',
        emergencyPhonePlaceholder: '请输入紧急联络人电话',
        extraListLabel: ['额外参与人员（限', '人）', '1'],
        addExtra: '添加额外参加人员',
        extraEmCheckbox: '使用和我相同的紧急联络人资料',
        rules1: {
          btn1: '「参加者须知及条款细则」',
          btn2: '「免责声明」',
          btn3: '「个人资料收集声明」',
          content: ['本人声明本人已年满18岁(年龄以活动当日计算)。本人及同行参加者细阅并同意本活动之', '、', '及', '。主办机构保留取消不接受上述条款之参加者的参加资格。']
        },
        rules2: {
          content: ['本人声明上述同行参​​加者中有18岁以下参加者。本人同意大会将会按本人所提供的电邮地址，以电邮提供家长/监护人同意书。本人明白必须于2019年2月15日或之前以电邮交回已签署之家长/监护人同意书相关参加者才可参与本活动。主办机构保留取消于限期前未能提交同意书之18岁以下参加者的参加资格。 (18岁以下参加者适用，年龄以活动当日计算)']
        },
        submit: '提交资料',
        tip: {
          existEmail: '该电邮已被使用',
          notice: '提示',
          delExtra: '是否删除此额外人员信息？',
          userName: '请输入正确姓名',
          phone: '请输入正确联系电话',
          email: '请输入正确电邮地址',
          emergencyPhone: '请输入正确紧急联系人的手提电话',
          emergencyName: '请输入正确紧急联系人的姓名',
          extrName: '请输入正确姓名',
          extrPhone: '请输入正确的手机号',
          extrEmergencyPhone: '请输入正确紧急联系人的手机号',
          extrEmergencyName: '请输入正确紧急联系人的姓名',
          extraExit: '此额外的参加者已报名，您可删减或增加其他参加者'
        },
        rule1: {
          title: '活动条款及细则',
          content: [
            '「新春行大运」由中国移动香港有限公司 (「中国移动香港」) 及中国香港旅行远足联会 (「旅联」) 联合主办。',
            '在下列的条款及细则内「活动」乃指2019年2月17日举行的「新春行大运」行山活动；「参加者」为参与是次活动的人士；「额外参加者」为参与是次活动的人士于报名时所申报同行的人士；「主办机构」为中国移动香港及旅联；「路线」是由主办机构指定的行山路线。',
            '活动于2019年1月24日开始接受报名，采用先到先得形式报名，额满后即时停止接受登记，亦不设候补名单。',
            '每名参加者可携同一名额外参加者同行。报名者将是该组参加者的组长。',
            '参与活动确认一经递交，即代表参加者及额外同行参加者确认及同意接受一切主办机构不时所定之活动的规则、条款和安排。',
            '18岁以下参加者必须于2019年2月15日或之前以电邮(WeWalk.enquiry@gmail.com)方式向主办机构提交已签署之家长/监护人同意书。主办机构保留取消于限期前未能提交同意书之18岁以下参加者的参加资格。'
          ]
        },
        rule2: {
          title: '活動細節',
          content: [
            '活動僅設有一條路線，起點為北潭涌傷健樂園，經北潭涌自然教育徑及上窰郊遊徑，終點為香港少年領袖團萬宜訓練營。每組參加者的組長必須於活動當日年滿18歲。所有參加者必須於活動當日年滿12歲。每名16歲以下之參加者必須由18歲或以上的成年人陪同參加。18歲以下的參加者必須事先獲家長或監護人簽署同意書方可參加。主辦機構保留在活動前後或進行期間，核實參加者年齡及(如有需要)該等同意書證明的權利。',
            '參加者於抵達終點香港少年領袖團萬宜訓練營後，主辦單位將於終點舉辦盆菜宴，並提供飲料。盆菜及飲料將由第三方機構提供。盆菜宴將於露天地方舉行，如遇惡劣天氣將移師至室內舉行。參加者可自行決定是否參與。',
            '主辦機構在得悉或懷疑情況下，保留、限制拒絕接受報名或取消任何不適宜參加本活動的參加權利，包括但不限於如申請者提供錯誤資料、不能提交報名表、不依從正確報名程序報名、或身體狀況不適宜參加本活動(如懷有身孕、患慢性疾病如心臟病及高血壓人士)。',
            '參加者必須最遲於活動當天上午9時45分抵達北潭涌傷健樂園，逾時者會被取消參加資格。若參加者未能按照其指定參加組別及時間起步，或未能依循所報名的路線完成活動，主辦機構有權取消其參加資格。',
            '參加者不可攜帶或使用任何滾軸鞋、滑板、手推車或其他大型物件，亦不可攜同任何動物參與。',
            '參加者於活動前後及進行期間，必須遵照主辦機構、授權人員以及其他工作人員包括警察、民眾安全服務隊、醫療輔助隊、食物環境衞生署及康樂及文化事務署的所有合法指示。',
            '參加者請於活動期間保持專業及禮貌的態度。',
            '步畢路線全程約2小時。沿途有上山路程，部分地區並無遮蓋，參加者需確保體力適宜才參與，如有疑問，應先向醫生查詢。由於鄰近萬宜水庫的道路為限制道路，沒有公共交通直達，如參加者未能步畢全程，可於中途退出，循原路折返起點。活動實際完結時間以主辦機構及授權人員所安排的押尾小隊決定為準。',
            '參加者需穿上合適的衣服及鞋襪，並自備充足飲品、食物、帽及雨具等。',
            '是次行山活動途徑泥路小徑，參加者須特別小心。請勿奔跑、爭先恐後、倚靠或攀爬沿途任何物件，以確保安全。',
            '參加者需自行承擔一切責任。主辦機構及授權機構並不會對參加者於活動當天因任何事情或理由所引致的任何個人傷亡或財物損失承擔任何責任。',
            '主辦機構保留更改條款細則、路線等安排的權利。',
            '主辦機構若認為參加者沒有完全遵照或違反本條款及細則的規定，主辦機構有權取消參加者的資格或於行山活動中任何時間內終止參加者繼續參加。主辦機構的判決為最終及不可推翻的決定。',
            '食品安全',
            '主辦機構將盡力確保食物安全，盆菜亦會徹底煮沸後才予參加者進食。',
            '提供盆菜及飲料的第三方機構或會在準備某些膳食時使用堅果和其他過敏原。主辦機構不能保證所提供的任何食物均不含過敏原。',
            '惡劣天氣',
            '如天文台於活動當日早上六時或之後懸掛黑色暴雨、紅色暴雨、雷暴或三號颱風警告，活動將會取消，主辦機構將另擇日子舉行活動。',
            '如活動進行中天氣惡劣或懸掛任何天氣警告，又或主辦機構評估後判斷當天並不適合舉行活動，主辦機構有權將活動路徑改變或取消正在進行中的活動。主辦機構不會另擇日子補辦活動。',
            '如是次活動因天氣惡劣或懸掛任何天氣警告或其他原因而取消，主辦機構將另行通知活動補辦日期。',
            '主辦機構強烈要求參加者於活動舉行當天早上致電香港天文台查詢天氣情況。(電話：1878200)',
            '其他事宜',
            '主辦機構不會提供行李寄存。切勿攜帶貴重物品，如有損毀或遺失，主辦機構將不會負任何責任及作出任何賠償。',
            '參加者如活動過程中須向主辦機構查詢及要求協助，請沿途與就近工作人員聯絡。',
            '所有由主辦機構提供的活動包、禮品及任何其他物品(「禮品」)不可兌換現金，亦不能更換、退款、轉讓及轉售。本活動所有的禮品視乎供應情況而定，換領完即止。每名參加者只可領取一份活動包，不可代他人領取。如任何因禮品所引起的爭議，主辦機構概不負責。',
            '主辦機構對供應商提供的商品或服務之品質、安全性及合法性，刊登內容之真實性及準確性，供應商的商譽與可信性均無控制力及保證。',
            '主辦機構已就活動購買第三者保險。參加者需自行負責個人意外保險。如參加者於活動開始前沒有於MyLink手機應用程式作電子簽到，則不獲活動第三者保險保障。',
            '主辦機構保留使用活動當天所拍得照片或錄像的權利，包括商業宣傳用途。',
            '主辦機構保留本活動的最終決定權。活動不設上訴機制。主辦機構擁有修改及解釋本條款規則的權利，任何有關活動的臨時改動或取消，將以主辦機構公布為準。',
            '本條款及細則受香港法律管轄。參加者同意任何因本條款及細則所引起的任何訴訟或索賠受香港法院的專屬司法管轄權管轄。',
            '本條款與細則的中、英文本如有任何歧義，概以英文本為準。',
            '如有任何爭議，主辦機構將保留一切最終決定權。'
          ]
        },
        rule3: {
          title: '免责声明',
          label: '谨此声明本人参加本活动，并愿意遵守由主办机构所订的条文及规则，以及同意以下所列各点：',
          content: ['本人是自愿参加此活动和愿意承担自身的意外风险及责任，并无权向主办机构对本人往返活动场地途中、活动中发生或引致之自身意外、死亡或任何形式的损失提出索偿或追讨责任。',
            '本人声明本人身体情况良好及有能力参加此活动，及没有执业医生曾提出相反意见。',
            '本人愿意接受主办机构要求及提供的药物检查及治疗。',
            '本人于活动当天（2019年2月17日）已经符合参加组别之最低年龄规定（如参加者未年满18岁，须由其家长或监护人签署同意声明）。',
            '本人明白及同意本人的个人资料将转交予主办机构用作活动安排之用途。',
            '本人证实已事先获得同行参加者及/或紧急联系人的同意，可使用其个人资料于本活动的报名表格作报名及/或紧急联系用途。',
            '本人愿意授权予及同意主办机构及传媒在不需要审查情况及不需要本人另外同意下而可使用本人的个人资料、肖像、姓名及声线作为筹办及推广活动之用，包括本人肖像及姓名有可能被使用于主办机构有关本活动之网页、短片及刊物。',
            '本人提交确认即表示同意及确认所有列明之「参加者须知及条款细则」、「免责声明」及「个人资料收集声明」，以及所有不时于活动指定宣传渠道更新的任何更改。'
          ]
        },
        rule4: {
          title: '个人资料收集声明',
          label: '',
          content: ['主办机构将会在参加者报名参与「新春行大运」行山活动并获即时确认出席资格时，收集参加者的个人资料，包括姓名、手提电话号码、电邮地址、病历记录、食物敏感资料等。主办机构保障参加者所提供之一切资料。当参加者提交确认时，有关个人资料将会被收集、储存及使用以作核实。',
            '本声明乃遵照《个人资料(私稳)条例》(第486章)的要求而发出，通知您作为参加者收集资料的目的、您同意主办机构如何使用这些资料及您的权利。本声明会不时更改，故请定期查阅。参加者每次登记及/或使用我们的服务时，即表示同意接受当时生效之个人资料收集声明。',
            '参加者可能会被要求向主办机构提供个人识别资料。为让参加者可以参加「新春行大运」行山活动，该些资料是必要的。倘若参加者未能提供所需资料，参加者将不能获得活动参加资格。'
          ],
          title1: '资料之目的及用途',
          label1: '主办机构所收集之资料将用作以下用途：',
          content1: ['识别和核实参加活动的参加者的身份及/或资格；',
            '就有关或因参加活动的事项与参加者或其紧急联系人沟通；',
            '汇编参加者的整体统计资料，分析、评估及改进主办机构所提供的活动'
          ],
          title2: '资料之转移',
          content2: ['参加者之个人资料将被保密。然而由于系统管理、运作及保养需要，主办机构会将有关资料转移或披露予对主办机构有保密责任并提供与主办机构运作有关行政、电讯、电脑系统服务、数据处理或其他服务的承办商。',
            '参加者有权根据《个人资料（私隐）条例》(第486章)的规定，要求查阅或更正参加者之个人资料。如有任何查阅或更正资料的要求，请向本公司资料保障主任提出，其办事处位于香港新界葵涌葵昌路51号九龙贸易中心1座20楼。主办机构的私隐政策声明可于其网页www.hk.chinamobile.com获取。',
          ]
        }
      },
      result: {
        title: '活动报名',
        contactTitle: '「新春行大运」万步有礼活动',
        contact: ['大会除了举办「新春行大运」活动，亦鼓励全港市民在全港任何一个角落一齐行，以健康的体魄迎接新一年，特意举办「万步有礼」活动。',
          '全港市民只要在2月17日当日开启并登入MyLink手机应用程式，透过WeWalk页面内的计步功能并步行够一万步，即可参加活动。'],
        list: [{
          label: '参加方法',
          li: ['登入MyLink',
            '开启「生活」内 WeWalk 页面',
            '当天行满一万步后，计步器将会发出提示']
        }, {
          label: '奖品',
          li: ['参加者只要成功在2月17 日行满10,000步后，即可获赠10,000 MyLink积分。（名额共1,000名，先到先得']
        }],
        p: ['电话：2127 4720 (星期一至五早上10时至晚上7时)', '电邮：wewalk.enquiry@gmail.com'],
        success: {
          title: '活动报名',
          article: '参与活动成功！！',
          info1: {
            label: '活动参与信息如下：',
            nameLabel: '姓名：',
            phoneLabel: '电话：',
            date: ['日期：', '2019年2月17日（星期日）'],
            time: ['时间：', '上午10时至下午3时'],
            route: ['集合地点：', '北潭涌 伤健乐园']
          },
          info2: {
            label: '额外参与人员：',
          },
          tips: ['主办机构于活动前透过MyLink手机应用程式及电邮发出提示，届时请留意活动最新资讯。']
        },
        beyond: {
          title: '活动报名',
          article: '抱歉！',
          info: ['感谢　阁下参与「新春行大运」活动。由于场地位置有限，活动已经额满。下一季度的活动详情将会适时公布。',
            '2月17日当天亦会举行「万步有礼」活动，敬请密切留意。']
        },
        // 签到
        fail: {
          title: '活动报名',
          article: '抱歉！',
          info: ['抱歉！当前报名人数过多，请稍后再试！']
        }
      }
    },
    query: {
      title: '万步有礼',
      home: {
        btn: ['查阅活动纪录', '活动已结束','活动将于2月17日开始！'],
        time:['活动时间：2月17日'],
        content1: {
          title: '活动介绍',
          p: ['大会除了举办「新春行大运」活动，亦鼓励全港市民在全港任何一个角落一齐行，以健康的体魄迎接新一年，特意举办「万步有礼」活动。',
            '全港市民只要在2月17日当日开启并登入MyLink手机应用程式，透过WeWalk页面内的计步功能并步行够一万步，即可参加活动。']
        },
        content2: {
          title: '活动规则',
          p: ['登入MyLink',
            '开启「生活」内 WeWalk 页面',
            '当天行满一万步后，计步器将会发出提示（名额共1,000名，先到先得）']
        },
        content3: {
          title: '如何打开MyLink计步器参与活动？',
          p: ['参与活动前，请查看生活-WeWalk页面步数信息是否显示正确（今日步数应大于0），如下图：', 'static/newYear/question-sc.jpg', '如有问题，请点此','查看原因']
        },
        rules: {
          title: ['查看', '活动条款及细则'],
          content: [
            {
              title: '主办机构',
              li: ['「新春行大运」万步有礼活动由中国移动香港有限公司（「中国移动香港」或「主办机构」）主办。',
                '在下列的条款及细则内，「活动」乃指2019年2月17日举行的「新春行大运」万步有礼活动；「活动期间」乃指香港时间2019年2月17日00:00至当日23:59；「参加者」为参与是次活动的合资格人士；「得奖者」为首1,000名参与活动并在MyLink手机应用程式内录得10,000步的参加者；「MyLink（手机应用程式） 」为由中国移动香港推出的MyLink手机应用程式；「指定奖品」是由主办机构指定的活动奖品，即MyLink积分10,000分。',
                '参加者一旦参与活动，即代表了解、同意并愿意遵守本文所载的条款及细则，如有违反条款、以不诚实手法进行此活动及/或造假者，中国移动香港有权取消其参加及得奖资格，而不作任何通知。',]
            }, {
              title: '参加资格',
              li: ['本活动只供年满18岁并持有香港身份证人士参加。于确认得奖时，中国移动香港有权向得奖者要求提交证明文件以核对账户身份。如未能出示有关证明，其得奖资格将会被取消。',
                '参加者必须于活动期间内使用香港注册的流动电话号码注册并登入MyLink参加本活动(每个香港流动电话号码只限参加活动一次)。如发现参加者以外挂程式或其他非正式途径如空号或假帐户或其他影响公平性的方式参加本活动，中国移动香港将取消该参加者的资格而不作另行通知。',
                '首1,000名已登入MyLink帐户的参加者于香港时间2019年2月17日00:00至当日23:59 (香港时间) 步行达10,000步或以上，即可获得指定奖品。 10,000步只以MyLink内计步功能计算为准，其他任何计步器纪录恕不接受。',
                '参加者必须于Google Play 或 App Store 下载MyLink。中国移动香港客户（包括现有的储值卡客户、服务计划客户及用身份证登记的企业客户）需以电话号码及客户密码登入MyLink；MySim客户及非中国移动客户需于活动专页输入电话及验证码登入MyLink。所有参加者必须同意本活动条款及细则，才可参加本活动。',
                '参加者必须提供支援短讯功能的香港手机号码以获得一次性验证码进行身份验证。如登记的手机号码不支援短讯功能或不能使用、无效或在领取礼品时已经更改，该得奖者资格会被取消。',
                '参加者必须于活动期间登入MyLink，并在计步期间一直开启MyLink及维持流动数据功能，活动期间累计步数将由香港时间2019年2月17日00:00开始截至当日23:59为止。',
                '中国移动香港保留对参加者资格的最终决定权。',
                '活动日期于香港时间2019年2月17日00:00至当日23:59期间进行。参加者完成活动时间以中国移动香港伺服器纪录之时间作准，逾时参与或完成将不获受理。',
                '如活动第1,000名得奖者与其他参加者完成时间相同，则无论得奖者是否已累积至1,000名，该批参加者亦可获发指定奖品。',
                '如主办机构怀疑参加者有（i）进行或与异常/可疑活动有关、（ii）使用不当的方法或欺诈行为而使本活动任何部份运作中断或受到干扰，导致技术问题，或检测到（ iii）任何不诚实的行为、提供虚假或不正确的资料或（iv）任何违反本条款及细则或其他任何适用法律或条文；主办机构拥有酌情权及最终决定权在不作任何通知及毋须对任何人士负上任何责任的情况下自行决定取消其参加及/或得奖资格，并对该人士保留追究权利。',
                '主办机构不会对延迟、遗失、传讯或无法识别参加者（包括但不限于任何电脑或互联网络之问题）提交的任何讯息引起或相关的事宜承担任何责任。',
                '参加者于登记参加本活动时所提供的资料均不能更改。如登记页面上所提供的资料有任何错漏、不实或不正确，该登记则被视为无效。如得奖者因提供了虚假、错漏或不正确的资料而导致无法收到领奖通知或不能领取礼品，主办机构毋须为此承担任何责任。',
                '主办机构保留随时更改本活动内容、终止本活动、修订此条款及细则的权利，而无需另行通知。',
                '(i)MyLink和(ii) MyLink积分奖励计划的条款及细则将继续适用。本活动受以上条款及细则约束。',
                '参加者对于是次活动及主办单位的决定均不得异议。活动不设上诉机制。中国移动香港拥有修改及解释以上规则的权利。如有任何争议，中国移动香港保留最终决定权。',
                '本条款及细则受香港法律管辖。参加者同意任何因本条款及细则所引起的任何诉讼或索赔受香港法院的专属司法管辖权管辖。',
                '本条款与细则的中、英文本如有任何歧义，概以英文本为准。',
                '除参加者和主办机构外，任何人均不享有《合约(第三者权利)条例》下的任何权利，以执行或享有本条款及细则任何条文的利益。',]
            }, {
              title: '参加须知',
              li: ['参加者须清楚明白本活动内容及性质，并知道本活动需要消耗体力，同时确定健康情况适宜参与本活动。主办机构建议所有参加者于活动期间自行留意个人的身体状况是否良好及是否适合参与本活动。参加者于活动期间如有不适，请立即停止活动，并按需要向医护人员求助。',
                '参加者参加本活动纯属自愿性质及需自行承担参加本活动之风险。任何参加者因参加本活动而引致之任何损失、伤害、费用、索赔、诉讼（包括但不限于直接、间接及后果性损失），主办机构概不负上任何法律责任或作出赔偿。']
            }, {
              title: '有关MyLink计步功能',
              li: ['参加者必须于活动期间开启MyLink及维持流动数据才能累积步数，如因任何技术中断或错误、网络挤塞或其他任何原因而产生或引致任何迟延、遗失、错误或无法辨识的回应、登记或提交等情况，主办机构概不负责。参加者明白及同意不会就MyLink的数据提出任何异议。',
                '参加者可在活动期间登入MyLink，检视MyLink计步器的步数',
                '参加者明白不同装置的计步器或有差距，一切结果会以主办机构的电脑系统所示的步数纪录为准。 iOS装置会存取Apple内置传感器的步数纪录；而Android装置会存取内置计步器/加速度传感器的步数纪录，任何其他第三方之计步方式均不获接受。',
                '计步功能只支援iOS版本9.0或以上及iPhone 5S或以上型号之手机，而Android手机则需内置计步感应器及系统为4.4或以上及之指定型号手机，并须视乎手机生产商对个别手机型号之设定为准。',
                '为确保MyLink可准确纪录参加者的步行步数，主办机构强烈建议参加者于每次步行前，到MyLink内的「生活」页面按「开始计步」、再按圆形开始按钮开始纪录步数，并于完成步行后长按圆形停止按钮停止纪录步数。']
            }, {
              title: '指定奖品',
              li: ['经主办机构验证并确认得奖者指定奖品的获奖资格后， MyLink积分10,000分将在2019年2月28日或之前自动存入得奖者注册的MyLink帐户。',
                'MyLink 积分余额显示在「我 - MyLink会员中心」页面。',
                '根据本活动授予的MyLink积分可以与其他促销活动或计划下授予的MyLink积分累积使用，有效期至2019年12月31日。已兑换奖赏或已过期的MyLink积分不会在任何情况下获发退款。',
                'MyLink积分没有现金价值和不能兑换现金。MyLink积分不能售出，退款、购买、分配或转让。',
                '获得MyLink积分后，得奖者可以在MyLink的「会员中心」兑换奖品。有关更多详情，请参阅MyLink积分奖励计划的条款及细则。',
                '除特别注明外，本活动的指定奖品不可与其他优惠同时享用。',
                '欺诈和滥用行为将导致参加者丧失参与活动的资格。主办机构保留暂停MyLink积分的派发、暂停相关MyLink账户或直接从相关MyLink账户扣除任何MyLink积分的权利，恕不另行通知。']
            }]
        }
      },
      status: {
        btn: '邀请好友参与',
        back: '活动详情',
        less: {
          title: '欢迎阁下参与活动',
          span: '活动期间累积步数：',
          p: ['今日步数', '距离获得积分还差', '步，继续加油哦！']
        },
        reach: {
          btn: '兑换礼品',
          tips: ['阁下已领取MyLink积分，感谢参与！'],
          rewards: ['在万步有礼活动中已获得', 'MyLink积分']
        },
        share:{
          title:'万步有礼活动',
          content:'邀请参与万步有礼活动'
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/locale/newYear/zh-cn.js